<template>
  <div class="profileView pa-4 responsive-height">
    <v-container class="custom-container">
      <v-row>
        <v-col lg="12" md="6" sm="12" cols="12">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-2" color="#708AA7">mdi mdi-account-outline</v-icon>Import Excel Data
              </v-card-title>
            </v-card-actions>

            <v-card-subtitle>
              Click the box below to select file or you can drag and drop your
              <span>xls, .xlsx</span>
              files.
            </v-card-subtitle>
            <div class="zone-wrapper">
              <v-card-text class="text-center">
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                  @vdropzone-success="handleUpload"></vue-dropzone>
                <div class="dropzone-content">
                  <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                  <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                  <span>File size max 2MB</span>
                </div>
              </v-card-text>
              <div class="details">
                <h3>Need Sample Excel File?</h3>
                <p>
                  Here We Have Linked 1 Excel File for an example. To get the
                  example file, Please
                  <a href="/sample.xlsx" download target="_blank">Click Here</a>
                </p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row class="mb-1">
              <v-col cols="12">
                <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here..." single-line solo
                  hide-details class="custom-v-input"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="12">
                <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                  <v-sheet class="transactionTable depositTabTable"
                    :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                    <v-data-table :headers="headers" :items="marketingusers" :search="search" :items-per-page="10">
                      <template v-slot:item.sl="{ item, index }">
                        {{ index + 1 }}
                      </template>
                    </v-data-table>
                  </v-sheet>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState, mapActions } from "vuex";
import { MARKETINGDATA__ACTIONS } from "@/store/action-types";


export default {
  name: "dropzoneView",
  data() {
    return {
      search: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFiles: 1,
        acceptedFiles: ".xlsx,.xls",
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
      },
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Mobile No", value: "phone" },
        { text: "Remarks", value: "remarks" },
      ],
    };
  },

  components: {
    vueDropzone: vue2Dropzone,
  },

  computed: {
    ...mapState("marketingdata", ["marketingusers"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("marketingdata", [
      MARKETINGDATA__ACTIONS.GETMARKETINGUSERS,
      MARKETINGDATA__ACTIONS.FILEUPLOAD,
    ]),
    
    async handleUpload(file) {
      const formData = new FormData();
      formData.append("excelfile", file);
      this[MARKETINGDATA__ACTIONS.FILEUPLOAD](formData);
    },
  },

  async created() {
    await this[MARKETINGDATA__ACTIONS.GETMARKETINGUSERS]();
  },
};
</script>
